import type { UserSkillRecord } from "../firebase-config";
import { normalizeText } from "./xpImport";


export const SKILL_MAX_EXP = 6667;


const SKILL_DISPLAY_NAME_MAP: Record<string, string> = {
  programacion: "Programación",
  programming: "Programación",
  programation: "Programación",
  programing: "Programación",
  prog: "Programación",
  art: "Arte",
  arte: "Arte",
  design: "Diseño",
  diseno: "Diseño",
  diseño: "Diseño",
};

export const getSkillDisplayName = (materia: string): string =>
  SKILL_DISPLAY_NAME_MAP[normalizeText(materia)] ?? materia;


export const skillExpToPercent = (exp: number): number =>
  Math.min(100, Math.round(((exp || 0) / SKILL_MAX_EXP) * 100));

export const getBestSkill = (
  skills: UserSkillRecord[],
): UserSkillRecord | null =>
  skills.reduce<UserSkillRecord | null>(
    (best, skill) =>
      !best || (skill.Progress ?? 0) > (best.Progress ?? 0) ? skill : best,
    null,
  );

export const getAverageSkillPercent = (skills: UserSkillRecord[]): number =>
  skills.length
    ? Math.round(
        skills.reduce(
          (acc, skill) => acc + skillExpToPercent(skill.Progress),
          0,
        ) / skills.length,
      )
    : 0;

export const AVERAGE_SKILL_HELP =
  "Es el promedio del avance de tus skills (Programación, Arte y Diseño). No es tu nota ni el avance total de la carrera.";
